/* eslint-disable no-console */
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "../store/";
Vue.use(VueRouter)

const routes = [
  {
    // ドメインのみ
    path: '/',
    name: 'root',
    component: () => import(/* webpackChunkName: "notfound" */ '../views/NotFound.vue')
  },
  {
    // TOP画面
    path: '/:brandPath',
    name: 'top',
    component: () => import(/* webpackChunkName: "top" */ '../views/Top.vue')
  },
  {
    // TOP画面プレビュー
    path: '/:brandPath/preview',
    name: 'topPreview',
    component: () => import(/* webpackChunkName: "topPreview" */ '../views/TopPreview.vue'),
    props: true,
    meta: {
      managerInfo:true,
      managerOnly: ['company'],
    }
  },
  {
    // 警告詳細画面
    path: '/:brandPath/AlertList',
    name: 'alertListIndex',
    component: () => import(/* webpackChunkName: "AlertList" */ '../views/AlertListIndex.vue'),
    props: (route) => ({
      brandPath: route.params.brandPath
    }),
    meta:{
      userInfo:true
    }
  },
  {
    // デイリーメニュー画面
    path: '/:brandPath/dailycheck/:menuId/index',
    name: 'dailyCheckMenuIndex',
    component: () => import(/* webpackChunkName: "dailyCheckMenu" */ '../views/DailyCheckMenuIndex.vue'),
    props: (route) => ({
     brandPath: route.params.brandPath,
     menuId: Number(route.params.menuId),
    }),
    meta:{
      userInfo:true
    }
  },
  {
    // デイリーメニュー画面(スナップ)
    path: '/:brandPath/dailycheck/:menuId/snap/index',
    name: 'dailyCheckMenuSnapIndex',
    component: () => import(/* webpackChunkName: "dailyCheckMenuSnap" */ '../views/DailyCheckMenuSnapIndex.vue'),
    props: (route) => ({
      brandPath: route.params.brandPath,
      menuId: Number(route.params.menuId),
    }),
    meta:{
      userInfo:true
    }
  },
  {
    // デイリーチェック画面
    path: '/:brandPath/dailycheck/:menuId/check/:subMenuId/:page(\\d+)?',
    name: 'dailyCheckMenuInput',
    component: () => import(/* webpackChunkName: "dailyCheckMenu" */ '../views/DailyCheckMenuInput.vue'),
    props: (route) => ({
      brandPath: route.params.brandPath,
      menuId: Number(route.params.menuId),
      subMenuId: Number(route.params.subMenuId),
      page: route.params.page ? Number(route.params.page) : 1, // ページャーのインデックス
    }),
    meta:{
      userInfo:true
    }
  },
    // デイリーチェックフリーコメント
  {
    path: '/:brandPath/dailycheck/:menuId/check/:subMenuId/freecomment',
    name: 'dailyCheckFreeComment',
    component: () => import(/* webpackChunkName: "DailyCheckFreeComment" */ '../views/DailyCheckFreeCommentIndex.vue'),
    props: (route) => ({
      brandPath: route.params.brandPath,
      menuId: Number(route.params.menuId),
      subMenuId: Number(route.params.subMenuId),
    }),
    meta:{
      userInfo:true
    }
  },
  {
    // 健康チェック画面
    path: '/:brandPath/:menuId/healthcheck',
    name: 'healthCheckInput',
    component: () => import(/* webpackChunkName: "healthCheckMenu" */ '../views/HealthCheckInput.vue'),
    props:true,
    meta:{
      userInfo:true
    }
  },
  {
    // 健康チェック遷移先画面
    path: '/:brandPath/healthcheck/:menuId/snap/index',
      name: 'healthCheckSnapIndex',
      component: () => import(/* webpackChunkName: "healthCheckMenu" */ '../views/HealthCheckSnapIndex.vue'),
      props:true,
      meta:{
    userInfo:true
    }
  },
  {
    // 重要管理項目メニュー画面
    path: '/:brandPath/cookingcheck/:menuId/index',
    name: 'cookingCheckIndex',
    component: () => import(/* webpackChunkName: "cookingCheckMenu" */ '../views/CookingCheckIndex.vue'),
    props:true,
    meta:{
      userInfo:true
    }
  },
  {
    // 重要管理項目メニュープレビュー画面
    path: '/:brandPath/cookingcheck/:menuId/index/preview',
    name: 'cookingCheckIndexPreview',
    component: () => import(/* webpackChunkName: "cookingCheckMenuPreview" */ '../views/CookingCheckIndexPreview.vue'),
    props:true,
    meta: {
      managerInfo:true,
      managerOnly: ['company'],
    }
  },
  // 報告書一覧
  {
    path: '/:brandPath/manage/report/monthly/:year(\\d+)?/:month(\\d+)?',
    name: 'calendar',
    component: () => import(/* webpackChunkName: "calendar" */ '../views/ReportMonthly.vue'),
    meta:{
      managerInfo:true,
      managerOnly: ['company', 'store', 'other']
    }
  },
  // 報告書詳細
  {
    path: '/:brandPath/manage/report/:year(\\d+)/:month(\\d+)/:day(\\d+)',
    name: 'report',
    props: (route) => {
      return {
        brandPath: route.params.brandPath,
        year: Number(route.params.year),
        month: Number(route.params.month),
        day: Number(route.params.day)
      }
    },
    component: () => import(/* webpackChunkName: "report" */ '../views/ReportDetail.vue'),
    meta:{
      managerInfo:true,
      managerOnly: ['company', 'store', 'other']
    }
  },
  {
    path: '/common/error',
    name: 'error',
    component: () => import(/* webpackChunkName: "error" */ '../views/Error.vue')
  },
  {
    path: '/history/error',
    name: 'historyError',
    component: () => import(/* webpackChunkName: "error" */ '../views/Error.vue')
  },
  // 不定期帳票報告書
  {
    path: '/:brandPath/manage/monthlyreport/:year(\\d+)/:month(\\d+)/:day(\\d+)',
    name: 'monthlyreport',
    props: (route) => {
      return {
        brandPath: route.params.brandPath,
        year: Number(route.params.year),
        month: Number(route.params.month),
        day: Number(route.params.day)
      }
    },
    component: () => import(/* webpackChunkName: "monthlyreport" */ '../views/ReportMonthlyDetail.vue'),
    meta:{
      managerInfo:true,
      managerOnly: ['company', 'store', 'other']
    }
  },
  // 不定期帳票報告書履歴
  {
    path: '/:brandPath/manage/comment_history/:year(\\d+)/:month(\\d+)/:day(\\d+)/:manager',
    name: 'monthlyCheckReportHistoryIndex',
    component: () => import(/* webpackChunkName: "monthlyCheckReportHistory" */ '../views/MonthlyCheckReportHistoryIndex.vue'),
    props: (route) => ({
      brandPath: route.params.brandPath,
      year: Number(route.params.year),
      month: Number(route.params.month),
      day: Number(route.params.day),
      manager: Number(route.params.manager)
    }),
    meta:{
      managerInfo:true,
      managerOnly: ['company', 'store', 'other']
    }
  },
    // 重要管理項目チェック画面
  {
    path: '/:brandPath/cookingcheck/:menuId/check/:subMenuId',
    name: 'cookingCheckInput',
    component: () => import(/* webpackChunkName: "cookingCheck" */ '../views/CookingCheckInput.vue'),
    props: (route) => {
      return {
        brandPath: route.params.brandPath,
        menuId: Number(route.params.menuId),
        subMenuId: Number(route.params.subMenuId),
        reInputFlg: route.params.reInputFlg,
        reCheckInputArray: route.params.reCheckInputArray,
      }
    },
    meta:{
      userInfo:true
    }
  },
  {
    // 重要管理項目チェックプレビュー画面
    path: '/:brandPath/cookingcheck/check/:subMenuId/preview',
    name: 'cookingCheckInputPreview',
    component: () => import(/* webpackChunkName: "cookingCheckMenuPreview" */ '../views/cookingCheckInputPreview.vue'),
    props: (route) => {
      return {
        subMenuId: Number(route.params.subMenuId),
      }
    },
    meta: {
      managerInfo:true,
      managerOnly: ['company', 'store'],
    }
  },
  {
    // スタッフ重要管理項目チェックプレビュー画面
    path: '/:brandPath/cookingcheck/check/:subMenuId/previewStore',
    name: 'cookingCheckInputStorePreview',
    component: () => import(/* webpackChunkName: "cookingCheckMenuPreview" */ '../views/cookingCheckInputStorePreview.vue'),
    props: (route) => {
      return {
        subMenuId: Number(route.params.subMenuId),
      }
    },
    meta: {
      userInfo:true,
    }
  },
  // 重要管理項目再計測画面
  {
    path: '/:brandPath/cookingcheck/:menuId/check/:subMenuId/reInput',
    name: 'cookingCheckReInput',
    component: () => import(/* webpackChunkName: "cookingCheck" */ '../views/CookingCheckInput.vue'),
    props: (route) => {
      return {
        brandPath: route.params.brandPath,
        menuId: Number(route.params.menuId),
        subMenuId: Number(route.params.subMenuId),
        reInputFlg: 1,
        reCheckInputArray: route.params.reCheckInputArray,
      }
    },
    meta:{
      userInfo:true
    }
  },
  {
    // 重要管理項目チェック履歴画面
    path: '/:brandPath/cookingcommnhistory/:subMenuId/:cookingId/index/:reInputFlg',
    name: 'cookingcommnhistoryindex',
    component: () => import(/* webpackChunkName: "DailyCheckFreeComment" */ '../views/CookingCommentHistoryIndex.vue'),
    meta:{
      userInfo:true
    }
  },
  {
    path: '/:brandPath/dailycheck/:pageId/commenthistory',
    name: 'dailyCheckCommentHistoryIndex',
    component: () => import(/* webpackChunkName: "DailyCheckCommentHistory" */ '../views/DailyCheckCommentHistoryIndex.vue'),
    props: (route) => ({
      brandPath: route.params.brandPath,
      pageId: Number(route.params.pageId),
    }),
    meta:{
      userInfo:true
    }
  },
  {
    path: '/:brandPath/managemenu',
    name: 'managemenu',
    component: () => import(/* webpackChunkName: "ManagerMenuList" */ '../views/ManageMenu.vue'),
    meta: {
      managerInfo:true,
      managerOnly: ['system', 'company', 'store', 'storeCommon', 'csvExport'],
    }
  },
  {
    // 企業一覧画面
    path: '/:brandPath/manage/commpanybrand',
    name: 'manageCommpanyBrandList',
    component: () => import(/* webpackChunkName: "CommpanyBrandList" */ '../views/ManageCommpanyBrandList.vue'),
    meta: {
      managerInfo:true,
      managerOnly: ['system', 'company', 'csvExport'],
    }
  },
  {
    // 企業詳細画面
    path: '/:brandPath/manage/:brandId/commpanybrand/Detail',
    name: 'manageCommpanyBrandDetail',
    component: () => import(/* webpackChunkName: "CommpanyBrandDetail" */ '../views/ManageCommpanyBrandDetail.vue'),
    props:true,
    meta: {
      managerInfo:true,
      managerOnly: ['system']
    }
  },
  {
    // 企業登録画面
    path: '/:brandPath/manage/commpanybrand/Add',
    name: 'manageCommpanyBrandAdd',
    component: () => import(/* webpackChunkName: "CommpanyBrandAdd" */ '../views/ManageCommpanyBrandAdd.vue'),
    meta: {
      managerInfo:true,
      managerOnly: ['system']
    }
  },
  {
    // 企業編集画面
    path: '/:brandPath/manage/:brandId/commpanybrand/Edit',
    name: 'manageCommpanyBrandEdit',
    component: () => import(/* webpackChunkName: "CommpanyBrandEdit" */ '../views/ManageCommpanyBrandEdit.vue'),
    props:true,
    meta: {
      managerInfo:true,
      managerOnly: ['company', 'csvExport']
    }
  },
  {
    // 店舗一覧画面
    path: '/:brandPath/manage/store',
    name: 'manageStoreList',
    component: () => import(/* webpackChunkName: "StoreList" */ '../views/ManageStoreList.vue'),
    meta: {
      managerInfo:true,
      managerOnly: ['company', 'store', 'storeCommon'],
      // ph3 managerOnlyの指定なし
    }
  },
  {
    // 店舗一覧画面(解約用)
    path: '/:brandPath/manage/storeCancel',
    name: 'manageStoreCancelList',
    component: () => import(/* webpackChunkName: "StoreList" */ '../views/ManageStoreCancelList.vue'),
    meta: {
      managerInfo:true,
      managerOnly: ['csvExport']
    }
  },
  {
    // 店舗詳細画面
    path: '/:brandPath/manage/store/Detail',
    name: 'manageStoreDetail',
    component: () => import(/* webpackChunkName: "StoreDetail" */ '../views/ManageStoreDetail.vue'),
    props:true,
    meta: {
      managerInfo:true,
      managerOnly: ['company'],
      // ph3 ['system', 'company']
    }
  },
  {
    // 店舗登録画面
    path: '/:brandPath/manage/store/Add',
    name: 'manageStoreAdd',
    component: () => import(/* webpackChunkName: "StoreAdd" */ '../views/ManageStoreAdd.vue'),
    meta: {
      managerInfo:true,
      managerOnly: ['storeCommon'],
    }
  },
  {
    // 店舗編集画面
    path: '/:brandPath/manage/store/Edit',
    name: 'manageStoreEdit',
    component: () => import(/* webpackChunkName: "StoreEdit" */ '../views/ManageStoreEdit.vue'),
    props:true,
    meta: {
      managerInfo:true,
      managerOnly: ['store'],
    }
  },
  {
    // スタッフ一覧
    path: '/:brandPath/manage/staffList',
    name: 'staffList',
    component: () => import(/* webpackChunkName: "staffList" */ '../views/ManageStaffList.vue'),
    meta:{
      managerInfo: true,
      managerOnly: ['store'],
      // managerOnly: ['system', 'store'] ph3
    }
  },
  {
    // スタッフ登録画面
    path: '/:brandPath/manage/staff/Add',
    name: 'manageStaffAdd',
    component: () => import(/* webpackChunkName: "StaffAdd" */ '../views/ManageStaffAdd.vue'),
    meta: {
      managerInfo:true,
      managerOnly: ['store'],
    }
  },
  {
    // スタッフ編集画面
    path: '/:brandPath/manage/staff/:id/Edit',
    name: 'manageStaffEdit',
    component: () => import(/* webpackChunkName: "StaffEdit" */ '../views/ManageStaffEdit.vue'),
    meta: {
      managerInfo:true,
      managerOnly: ['store'],
    }
  },
  {
    // 温度湿度一覧画面
    path: '/:brandPath/manage/temperature',
    name: 'manageTemperatureList',
    component: () => import(/* webpackChunkName: "temperature" */ '../views/ManageTemperatureList.vue'),
    meta: {
      managerInfo:true,
      managerOnly: ['company','other'],
    }
  },
  {
    // 温度湿度一覧画面
    path: '/:brandPath/manage/storeTemperature',
    name: 'storeTemperatureList',
    component: () => import(/* webpackChunkName: "storeTemperature" */ '../views/StoreTemperatureList.vue'),
    meta: {
      userInfo:true
    }
  },
  {
    // チェック設定一覧画面
    path: '/:brandPath/manage/checkList',
    name: 'manageCheckMenuList',
    component: () => import(/* webpackChunkName: "CheckMenuList" */ '../views/ManageCheckMenuList.vue'),
    meta: {
      managerInfo:true,
      managerOnly: ['company'],
    }
  },
  {
    // チェック内容設定画面
    path: '/:brandPath/manage/check/:bottunid/ViewSetting',
    name: 'manageCheckViewSetting',
    component: () => import(/* webpackChunkName: "CheckViewSetting" */ '../views/ManageCheckViewSetting.vue'),
    props:true,
    meta: {
      managerInfo:true,
      managerOnly: ['company'],
    }
  },
  {
    // チェックページ設定画面
    path: '/:brandPath/manage/check/:bottunid/ViewSetting/:page/pagesetting',
    name: 'manageCheckViewSettingPage',
    component: () => import(/* webpackChunkName: "CheckViewSettingPage" */ '../views/ManageCheckViewSettingPage.vue'),
    props:true,
    meta: {
      managerInfo:true,
      managerOnly: ['company'],
    }
  },
  {
    // 身だしなみチェック内容設定画面
    path: '/:brandPath/manage/check/:bottunid/healthViewSetting',
    name: 'manageHealthCheckViewSetting',
    component: () => import(/* webpackChunkName: "HealthCheckViewSetting" */ '../views/ManageHealthCheckViewSetting.vue'),
    props:true,
    meta: {
      managerInfo:true,
      managerOnly: ['company'],
    }
  },
  {
    // デイリーメニュープレビュー
    path: '/:brandPath/dailycheck/:menuId/index/preview',
    name: 'dailyCheckMenuIndexPreview',
    component: () => import(/* webpackChunkName: "dailyCheckMenuIndexPreview" */ '../views/DailyCheckMenuIndexPreview.vue'),
    props: (route) => ({
      menuId: Number(route.params.menuId),
    }),
    meta: {
      managerInfo:true,
      managerOnly: ['company'],
    }
  },
  {
    // デイリーチェックプレビュー
    path: '/:brandPath/dailycheck/:menuId/check/:subMenuId/preview',
    name: 'dailyCheckMenuInputPreview',
    component: () => import(/* webpackChunkName: "dailyCheckMenu" */ '../views/DailyCheckMenuInputPreview.vue'),
    props: (route) => ({
      menuId: Number(route.params.menuId),
      subMenuId: Number(route.params.subMenuId),
    }),
    meta:{
      managerInfo:true,
      managerOnly: ['company'],
    }
  },
    // パスワード初期設定
  {
    path: '/:brandPath/manage/password/initialSetting',
    name: 'passwordInitialSetting',
    component: () => import(/* webpackChunkName: "PasswordSetting" */ '../views/PasswordSetting.vue'),
    meta: {
      managerInfo:true,
      passwordInitPath: true,
      managerOnly: ['company', 'store', 'csvExport'],
    }
  },
  {
    // センサー情報一覧
    path: '/:brandPath/manage/senser/list',
    name: 'manageSenserList',
    component: () => import(/* webpackChunkName: "SenserList" */ '../views/ManageSenserList.vue'),
    meta: {
      managerInfo:true,
      managerOnly: ['store'],
      // managerOnly: ['system', 'store'] ph3
    }
  },
  {
    // センサー閾値登録
    path: '/:brandPath/manage/senser/setting',
    name: 'manageSenserSetting',
    component: () => import(/* webpackChunkName: "SenserSetting" */ '../views/ManageSenserSetting.vue'),
    meta: {
      managerInfo:true,
      managerOnly: ['company']
      // managerOnly: ['system', 'company']
    }
  },
  {
    // 調理名登録
    path: '/:brandPath/manage/tyori/setting',
    name: 'manageTyoriSetting',
    component: () => import(/* webpackChunkName: "TyoriSetting" */ '../views/ManageTyoriSetting.vue'),
    meta: {
      managerInfo:true,
      managerOnly: ['company'],
      //managerOnly: ['system', 'company'],
    }
  },
  {
    // 当日調理名登録
    path: '/:brandPath/manage/tyori/storesetting',
    name: 'manageStoreTyoriSetting',
    component: () => import(/* webpackChunkName: "StoreTyoriSetting" */ '../views/ManageStoreTyoriSetting.vue'),
    props: (route) => {
      return {
        brandPath: route.params.brandPath,
        menuId: Number(route.params.menuId),
        subMenuId: Number(route.params.subMenuId),
      }
    },
    meta: {
      userInfo:true,
    }
  },
  {
    // 衛生管理計画書画面
    path: '/:brandPath/hygiene_management_plan',
    name: 'plan',
    component: () => import(/* webpackChunkName: "HygieneManagementPlan" */ '../views/ManageHygieneManagementPlan.vue'),
    meta:{
      userInfo:true
    }
  },
  {
    // 衛生管理計画書 デイリーチェック画面
    path: '/:brandPath/dailycheck/:menuId/check/:subMenuId/snap/:page(\\d+)?',
    name: 'dailyCheckMenuInputSnap',
    component: () => import(/* webpackChunkName: "dailyCheckMenuSnapInput" */ '../views/DailyCheckMenuSnapInput.vue'),
    props: (route) => ({
      brandPath: route.params.brandPath,
      menuId: Number(route.params.menuId),
      subMenuId: Number(route.params.subMenuId),
      page: route.params.page ? Number(route.params.page) : 1, // ページャーのインデックス
    }),
    meta:{
      userInfo:true
    }
  },
  {
    // 衛生管理計画書 デイリーチェックフリーコメント画面
    path: '/:brandPath/dailycheck/:menuId/check/:subMenuId/snap/freeComment',
    name: 'dailyCheckFreeCommentSnap',
    component: () => import(/* webpackChunkName: "DailyCheckFreeCommentSnap" */ '../views/DailyCheckFreeCommentSnapIndex.vue'),
    props: (route) => ({
      brandPath: route.params.brandPath,
      menuId: Number(route.params.menuId),
      subMenuId: Number(route.params.subMenuId),
    }),
    meta:{
      userInfo:true
    }
  },
  // 衛生管理計画書 重要管理項目画面
  {
    path: '/:brandPath/cookingcheck/:menuId/snap/:subMenuId',
    name: 'cookingCheckInputSnap',
    component: () => import(/* webpackChunkName: "cookingCheckInputSnap" */ '../views/CookingCheckInputSnap.vue'),
    props: (route) => {
      return {
        brandPath: route.params.brandPath,
        menuId: Number(route.params.menuId),
        subMenuId: Number(route.params.subMenuId),
      }
    },
    meta:{
      userInfo:true
    }
  },
  {
    // 衛生管理計画書設定
    path: '/:brandPath/manage/hygiene_management_plan/setting',
    name: 'manageHygieneManagementPlanSetting',
    component: () => import(/* webpackChunkName: "HygieneManagementPlanSetting" */ '../views/ManageHygieneManagementPlanSetting.vue'),
    meta: {
      managerInfo:true,
      managerOnly: ['company']
      // managerOnly: ['system', 'company']
    }
  },
  {
    // CSV出力画面
    path: '/:brandPath/manage/csvExport',
    name: 'manageCsvExport',
    component: () => import(/* webpackChunkName: "CsvExport" */ '../views/ManageCsvExport.vue'),
    meta: {
      managerInfo:true,
      managerOnly: ['csvExport']
    }
  },
  {
    // 店舗選択画面
    path: '/:brandPath/manage/store/select',
    name: 'manageStoredSelect',
    component: () => import(/* webpackChunkName: "StoreSelect" */ '../views/ManageStoreSelect.vue'),
    props:true,
    meta: {
      managerInfo:true,
      managerOnly: ['company','other'],
    }
  },
  // ダッシュボード
  {
    path: '/:brandPath/dashboard',
    name: 'dashboard',
    component: () => import(/* webpackChunkName: "Dashboard" */ '../views/Dashboard.vue'),
    meta:{
      managerInfo:true,
      managerOnly: ['company']
    }
  },
  // ダッシュボード温湿度異常未対応店舗リスト画面
  {
    path: '/:brandPath/dashboard/alertList',
    name: 'dashboardAlertList',
    component: () => import(/* webpackChunkName: "DashboardAlertList" */ '../views/DashboardAlertList.vue'),
    props: (route) => ({
      startDate: route.params.startDate,
      endDate: route.params.endDate,
    }),
    meta:{
      managerInfo:true,
      managerOnly: ['company']
    }
  },
  // ダッシュボード温湿度異常未対応店舗別月間推移画面
  {
    path: '/:brandPath/dashboard/alertList/monthlyChart',
    name: 'dashboardAlertListChart',
    component: () => import(/* webpackChunkName: "DashboardAlertList" */ '../views/DashboardAlertListChart.vue'),
    props: (route) => ({
      startDate: route.params.startDate,
      endDate: route.params.endDate,
    }),
    meta:{
      managerInfo:true,
      managerOnly: ['company']
    }
  },
  // チェック実施設定一覧画面（ダッシュボード用）
  {
    path: '/:brandPath/manage/checkImplementationList',
    name: 'manageCheckImplementationMenuList',
    component: () => import(/* webpackChunkName: "CheckImplementationMenuList" */ '../views/ManageCheckImplementationMenuList.vue'),
    meta:{
      managerInfo:true,
      managerOnly: ['store']
    }
  },
  // チェック実施設定画面（ダッシュボード用）
  {
    path: '/:brandPath/manage/check/:bottunid/implementationViewSetting',
    name: 'manageCheckImplementationViewSetting',
    component: () => import(/* webpackChunkName: "CheckImplementationViewSetting" */ '../views/ManageCheckImplementationViewSetting.vue'),
    props:true,
    meta: {
      managerInfo:true,
      managerOnly: ['store'],
    }
  },
  // チェック実施ページ設定画面（ダッシュボード用）
  {
    path: '/:brandPath/manage/check/:bottunid/ViewSetting/:page/implementationPageSetting',
    name: 'manageCheckImplementationViewSettingPage',
    component: () => import(/* webpackChunkName: "CheckImplementationViewSettingPage" */ '../views/ManageCheckImplementationViewSettingPage.vue'),
    props:true,
    meta: {
      managerInfo:true,
      managerOnly: ['store'],
    }
  },
  // ダッシュボードエリア設定画面
  {
    path: '/:brandPath/manage/dashboardAreaSetting',
    name: 'dashboardAreaSetting',
    component: () => import(/* webpackChunkName: "dashboardAreaSetting" */ '../views/DashboardAreaSetting.vue'),
    props:true,
    meta: {
      managerInfo:true,
      managerOnly: ['company'],
    }
  },
  // ダッシュボード表示設定画面
  {
    path: '/:brandPath/manage/dashboardViewSetting',
    name: 'dashboardViewSetting',
    component: () => import(/* webpackChunkName: "dashboardViewSetting" */ '../views/DashboardViewSetting.vue'),
    props:true,
    meta: {
      managerInfo:true,
      managerOnly: ['company'],
    }
  },
  // ダッシュボード健康身だしなみ重要管理項目CSV出力
  {
    path: '/:brandPath/manage/dashboardCookingHealthList',
    name: 'dashboardCookingHealthListIndex',
    component: () => import(/* webpackChunkName: "DashboardCookingHealthListIndex" */ '../views/DashboardCookingHealthListIndex.vue'),
    props: (route) => ({
      startDate: route.params.startDate,
      endDate: route.params.endDate,
    }),
    meta: {
      managerInfo:true,
      managerOnly: ['company'],
    }
  },
  {
    // 報告書コメント通知画面
    path: '/:brandPath/reportCommentAlertList',
    name: 'reportCommentAlertListIndex',
    component: () => import(/* webpackChunkName: "ReportCommentAlertListResource" */ '../views/ReportCommentAlertListIndex.vue'),
    props: (route) => ({
      brandPath: route.params.brandPath
    }),
    meta:{
      userInfo:true
    }
  },
  // お知らせ設定画面
  {
    path: '/:brandPath/manage/release',
    name: 'releaseSettingIndex',
    component: () => import(/* webpackChunkName: "releaseSettingIndex" */ '../views/ReleaseSettingIndex.vue'),
    props:true,
    meta: {
      managerInfo:true,
      managerOnly: ['system'],
    }
  },
  // 調理名機器設定画面
  {
    path: '/:brandPath/manage/manageSensorAssignmentCookingName',
    name: 'manageSensorAssignmentCookingName',
    component: () => import(/* webpackChunkName: "manageSensorAssignmentCookingName" */ '../views/ManageSensorAssignmentCookingName.vue'),
    props:true,
    meta: {
      managerInfo:true,
      managerOnly: ['store'],
    }
  },
  // 熱中症温度確認画面
  {
    path: '/:brandPath/heatStrokeIndexMap',
    name: 'manageHeatStrokeIndexMap',
    component: () => import(/* webpackChunkName: "manageHeatStrokeIndexMap" */ '../views/ManageHeatStrokeIndexMap.vue'),
    props:true,
    meta: {
      managerInfo:true,
      managerOnly: ['store'],
    }
  },
  {
    path: '*',
    name: 'notFound',
    component: () => import(/* webpackChunkName: "notfound" */ '../views/NotFound.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: '/',
  //base: process.env.BASE_URL,
  routes
})

function handleError(error, next) {
  store.dispatch('spinner/setLoading', false)
  store.dispatch('error/setError', error).then(next({name: 'error'}))
}

router.beforeEach(async (to, from, next) => {
  store.dispatch('spinner/setLoading', true)

  let error = {
    message: '予期しないエラーが発生しました。',
    button: {
      text: 'トップに戻る',
      path: {name: 'top'},
    }
  }

  const axios = router.app.$axios
  const endpoint = router.app.$apiEndpoint
  let brandPath = null
  const adminPath = process.env.VUE_APP_ADMIN_BRAND_PATH

  // ブランドパスチェックとブランド情報のセット
  if ('brandPath' in to.params) {
    brandPath = to.params.brandPath

    // TODO: システム管理者用に払い出すパスの決定
    if (brandPath !== adminPath) {
      await store.dispatch('brand/fetchBrand', {axios:axios, endpoint: endpoint, brandPath:brandPath})
          .catch(err => {
            if (err.customError) {
              error = Object.assign(error, err.customError)
            }
            handleError(error, next)
          })
    }
    // 戻るボタンの遷移先にブランドパスを追加
    error.button.path.params = { brandPath: brandPath }
  }

  // 名前選択の必要な画面
  if (to.matched.some(m => m.meta.userInfo)) {
    // スタッフの情報を持っているか（スタッフ主キー、スタッフID、スタッフ名が必要）
    if (! store.getters['staff/exists']) {
      error.id = '801'
      error.code = '403'
      error.message = 'トップ画面に戻って名前を選択しなおしてください。'
      handleError(error, next)
      return
    }
  }

  if (to.matched.some(m => m.meta.managerInfo)) {
    // 管理者の情報を持っているか（主キー、区分が必要）
    if (!store.getters['manager/exists']) {
      error.id = '802'
      error.code = '403'
      error.message = 'トップ画面に戻ってパスワードを入力しなおしてください。'
      handleError(error, next)
      return
    }
    // パスワード初期化フラグが立ってないか
    if (store.getters['manager/isInitPassword'] &&  ! to.matched.some(m => m.meta.passwordInitPath)) {
      next({name: 'passwordInitialSetting', params: {brandPath: brandPath}, query: {redirect: to.fullPath}})
      return
    }
  }

  // 管理者権限の必要な画面
  const forbidden = to.matched.some(m => {
    return m.meta.managerOnly && ! m.meta.managerOnly.includes(store.getters['manager/authorityKbnName'])
  })

  // 許可されている区分か
  if (forbidden) {
    error.id = '803'
    error.code = '403'
    error.message = 'アクセスが許可されていないページです。'
    handleError(error, next)
    return
  }
    next()
})

router.afterEach(()=>{
 store.commit('spinner/setLoading', false)
})

export default router
